import { render, staticRenderFns } from "./shareDialog.vue?vue&type=template&id=532ce346&scoped=true"
import script from "./shareDialog.vue?vue&type=script&lang=js"
export * from "./shareDialog.vue?vue&type=script&lang=js"
import style0 from "./shareDialog.vue?vue&type=style&index=0&id=532ce346&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532ce346",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('532ce346')) {
      api.createRecord('532ce346', component.options)
    } else {
      api.reload('532ce346', component.options)
    }
    module.hot.accept("./shareDialog.vue?vue&type=template&id=532ce346&scoped=true", function () {
      api.rerender('532ce346', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/cloudfile/components/shareDialog.vue"
export default component.exports